const SCRIPT_URL = "/shared/cmo-digital-personalization.js";

export const initCMODigitalPersonalizationScript = () =>
  new Promise((resolve) => {
    const scriptElement = document.createElement("script");

    scriptElement.setAttribute("src", SCRIPT_URL);
    scriptElement.setAttribute("async", "");
    scriptElement.addEventListener("load", resolve);

    document.head.appendChild(scriptElement);
  });
